import styled, {css} from 'styled-components'

const linkCss = css`
  color: ${props => props.theme.black};
  font-weight: bold;
  text-decoration: none;

  margin-right: 1em;

  ${props => props.large && css`
    font-size: 1.25em;
  `}
  ${props => props.small && css`
    font-size: 1em;
  `}

  ${props => props.margin && css`
    margin: ${props.margin};
  `}
  // ${props => props.padding && css`
  //   padding: ${props.padding};
  // `}


  ${props => props.background && css`
    @media (max-width: ${props.theme.small} ){

      background: ${props.background};
    }
  `}
  //
  // ${props => props.border && css`
  //   border: ${props.theme.borderStyle};
  // `}

  ${props => props.underline && css`
    &:hover {
      text-decoration: underline;
    }
  `}

  ${props => props.active && css`
    // text-decoration: underline;
    border-bottom: 2px solid black;
  `}

  ${props => props.marginBottom && css`
    margin-bottom: ${props.marginBottom};
  `}
  cursor: crosshair;


`
export {linkCss}

export default styled.a`
  ${linkCss}
`



// WEBPACK FOOTER //
// ./src/shared/A.js